import { useContext, useEffect } from 'react';

import { ColSize, RowSize } from '../../../shared/components';
import { PageHeader } from '../../../shared/components/MainLayout/components';
import { SavedQuotesContainer } from './shared/components';

import { InfoContext } from '../../../shared/contexts';
import { SavedQuotesProvider } from './shared/contexts';

export const SavedQuotes = () => {
  const { setTitle } = useContext(InfoContext);

  useEffect(() => {
    setTitle('Cotizaciones Guardadas');
    /* eslint-disable-next-line */
  }, []);

  return (
    <RowSize>
      <ColSize size={100}>
        <PageHeader />
      </ColSize>
      <ColSize size={100}>
        <SavedQuotesContainer />
      </ColSize>
    </RowSize>
  );
};

export const SavedQuotesPage = () => (
  <SavedQuotesProvider>
    <SavedQuotes />
  </SavedQuotesProvider>
);
